import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "textarea-label d-flex align-items-center"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["value", "rows", "data-testid", "disabled", "placeholder"]

import { computed, VNode } from 'vue';

import { InputVariant } from '@/types';

interface Props {
  label?: string;
  labelIcon?: string | object | (() => VNode) | null;
  modelValue?: string | number;
  required?: boolean;
  placeholder?: string;
  rows?: number
  disabled?: boolean;
  testId?: string;
  variant?: InputVariant;
  textareaClass?: string;
  textareaStyle?: Record<string, string>;
}
export default /*@__PURE__*/_defineComponent({
  __name: 'TextArea',
  props: {
    label: { default: "" },
    labelIcon: { type: [String, Object, Function, null], default: null },
    modelValue: { default: "" },
    required: { type: Boolean, default: false },
    placeholder: { default: "" },
    rows: { default: 1 },
    disabled: { type: Boolean, default: false },
    testId: { default: "textarea" },
    variant: { default: "primary" },
    textareaClass: {},
    textareaStyle: {}
  },
  setup(__props: any) {

;

const props = __props;

const variantClass = computed(() => props.variant ?? 'primary');
const backgroundStyle = computed(() => ({
  background:
    props.modelValue && ["primary", "admin"].includes(props.variant)
      ? "rgba(28, 86, 145, 0.05)"
      : "none",
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(['w-100', variantClass.value])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true),
          (__props.labelIcon)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.labelIcon), {
                key: 1,
                class: "ms-1"
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("textarea", _mergeProps({
      onInput: _cache[0] || (_cache[0] = e => _ctx.$emit('update:modelValue', (e.target as HTMLTextAreaElement).value)),
      value: __props.modelValue,
      rows: __props.rows,
      "data-testid": __props.testId,
      disabled: __props.disabled,
      placeholder: __props.placeholder,
      style: { ...backgroundStyle.value, ...__props.textareaStyle },
      class: __props.textareaClass
    }, _ctx.$attrs), null, 16, _hoisted_3)
  ], 2))
}
}

})